// src/pages/Auth/components/EmailStep.js

import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { LOADING_STATES } from '../constants';
import { StyledInput, StyledButton } from '../styles/Styles';

const EmailStep = ({ email, setEmail, loadingState, onSubmit, isDarkMode }) => {
  const isLoading = loadingState === LOADING_STATES.EMAIL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <Box mb={3}>
          <Typography 
            component="label" 
            htmlFor="auth-email"
            sx={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              marginBottom: "8px", 
              display: "block",
              color: isDarkMode ? "#e2e8f0" : "#374151"
            }}
          >
            Email Address
          </Typography>
          <StyledInput
            id="auth-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Your Email Address"
            isDarkMode={isDarkMode}
          />
        </Box>
        <StyledButton
          type="submit"
          variant="contained"
          fullWidth
          disabled={isLoading}
          isDarkMode={isDarkMode}
        >
          {isLoading ? (
            <Box display="flex" alignItems="center" justifyContent="center" gap={1.5}>
              <CircularProgress size={20} sx={{ color: "white" }} />
              <Typography sx={{ color: "white" }}>Verifying...</Typography>
            </Box>
          ) : (
            "Continue with Email"
          )}
        </StyledButton>
      </Box>
    </form>
  );
};

export default React.memo(EmailStep);